import { createReducer, on } from '@ngrx/store';
import * as ShopActions from './shop.actions';

export interface ShopState {
  selectedShop: any | null;
}

export const initialShopState: ShopState = {
  selectedShop: null,
};

export const shopReducer = createReducer(
  initialShopState,
  on(ShopActions.selectShop, (state, { shop }) => ({ ...state, selectedShop: shop })),
  on(ShopActions.clearShopState, () => ({ ...initialShopState }))
);
